import * as yup from "yup";
import { FormGroup } from "../../../../components/form";

export const applicationApprovalFormLegacy: FormGroup = {
  type: "formGroup",

  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "sectionHeader",
      },
      label: "Application Decision",
    },
    {
      type: "field",
      key: "isApplicationEligible",
      label: "Is the Application Eligible?",
      fieldType: "radio",
      props: {
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      validation: yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      key: "howWasDisabilityEstablished",
      label: "How was Disability Established?",
      fieldType: "radio",
      props: {
        options: [
          { value: "NDIS Participant", label: "NDIS Participant" },
          { value: "ECIS Eligible", label: "ECIS Eligible" },
          {
            value: "Disability or Developmental delay, supporting documentation provided",
            label: "Disability or Developmental delay, supporting documentation provided",
          },
          {
            value: "Continuing assessment for disability, supporting documentation provided",
            label: "Continuing assessment for disability, supporting documentation provided",
          },
          {
            value: "Disability not established, application assessed as eligible under CMN only",
            label: "Disability not established, application assessed as eligible under CMN only",
          },
        ],
      },
      validation: yup.string().trim().required("A response is required"),

      hideExpression: (context, values) => values.isApplicationEligible !== "Yes" || context.isComplex,
    },
    {
      type: "formGroup",
      key: "reasonIneligible",
      label: "Reason the Application was Ineligible",
      hideExpression: (context, values) => values.isApplicationEligible !== "No",
      test: [
        "chooseOne",
        "A response is required",
        (value: any) => {
          return value.notEligible || value.disabilityNotEstablished || value.childNotMeetCriteria;
        },
      ],
      props: {
        isRequired: true,
      },
      fields: [
        {
          type: "field",
          key: "notEligible",
          fieldType: "checkbox",
          label: "Not eligible for the program",
        },
        {
          type: "field",
          key: "disabilityNotEstablished",
          fieldType: "checkbox",
          label: "Disability not established",
        },
        {
          type: "field",
          key: "childNotMeetCriteria",
          fieldType: "checkbox",
          label: "Child does not meet criteria",
        },
        {
          type: "formGroup",
          key: "criteriaNotMeet",
          label: "Indicate which criteria the child does not meet",
          hideExpression: (context, values) => !values.reasonIneligible.childNotMeetCriteria,
          test: [
            "chooseOne",
            "A response is required",
            (value: any) => {
              return value.complexNeedsNotEstablished || value.significantRiskNotEstablished || value.restrictedMovementNotEstablished;
            },
          ],
          props: {
            isRequired: true,
          },
          fields: [
            {
              type: "field",
              key: "complexNeedsNotEstablished",
              fieldType: "checkbox",
              label: "Complex Medical Needs not established",
            },
            {
              type: "field",
              key: "significantRiskNotEstablished",
              fieldType: "checkbox",
              label: "Significant Risk not established",
            },
            {
              type: "field",
              key: "restrictedMovementNotEstablished",
              fieldType: "checkbox",
              label: "Restricted Capacity of Movement not established",
            },
          ],
        },
      ],
    },

    {
      type: "field",
      fieldType: "textarea",
      label: "Additional Explanation",
      key: "additionalExplanation",
      warn: "Provide a short summary explaining why the application was ineligible. This will be provided to the kindergarten.",
      validation: yup.string().trim().required("A response is required"),
      hideExpression: (context, values) => values.isApplicationEligible === "Yes",
    },
    {
      type: "field",
      key: "whichEligibilityCriteria",
      fieldType: "dropdown",
      label: "Which eligibility criteria does the child meet?",
      props: {
        placeholder: "Select an application type",
        options: [
          {
            label: "Disability only",
            value: 1,
          },
          {
            label: "Disability with Complex Medical Needs",
            value: 2,
          },
          {
            label: "Complex Medical Needs only",
            value: 3,
          },
        ],
      },
    },
    {
      type: "formGroup",
      key: "eligibleApplicationCategory",
      label: "Eligible Application Category",
      fields: [
        {
          type: "field",
          fieldType: "checkbox",
          key: "significantRisk",
          label: "Significant risk",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "restrictedCapacityForMovement",
          label: "Restricted capacity for movement",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "notProvided",
          label: "Not Provided",
        },
      ],
    },
    {
      type: "formGroup",
      key: "transferredApplicationHeader",
      label: "Transferred Application",
      fields: [
        {
          type: "field",
          fieldType: "checkbox",
          key: "transferredApplication",
          label: "Transferred application",
        },
      ],
    },
  ],
};
